module.exports = __webpack_public_path__ + "static/media/ai23-bg.50e6f053.jpg";